/******************************************************************************
NOTE: This is the newer, webpack version of the CROMERR widget.
Any changes made here will also need to be made to the non-webpack version,
located at ../cromerrWidget.js (relative to this file).
******************************************************************************/

require('./bootstrap-cromerr-widget.min.css');
require('./style.css');

let $jQueryCromerrWidget = require('jquery');
require('jquery-validation');
require('bootstrap');

function initializeCromerrWidget(config) {
    //config.widgetParams.oidcSessionFailureMessage
    //config.widgetParams.idToken
    //config.widgetParams.firstName
    //config.widgetParams.lastName
    //config.widgetParams.middleInitial
    //config.widgetParams.organizationName
    //config.widgetParams.createActivityUrl;
    var pathSrc = $('#cromerrServerSign').attr('src');
    var baseUrl = '';
    var widgetCancelled = true;
    var dialogCancelled = true;
    var openingSignatureWidget = false;
    var isOIDCMigratedUser = false;
    var secondFactorConfig = {};
    var userData = {};

    $jQueryCromerrWidget.ajaxSetup({
        xhrFields: {
            withCredentials: true
        }
    });

    if (pathSrc.indexOf('/Content/CromerrWidget') != -1) {
        baseUrl = pathSrc.substring(0, pathSrc.indexOf('/Content/CromerrWidget'));
    }
    else if (pathSrc.indexOf('/ContentFramework') != -1) {
        baseUrl = pathSrc.substring(0, pathSrc.indexOf('/ContentFramework'));
    }

    var loadingIconPath = baseUrl + '/Content/CromerrWidget/images/indicator.gif';

    function goToLoginForm() {
        $jQueryCromerrWidget('#autoAuth').hide();
        $jQueryCromerrWidget('#loginButton').show();
        $jQueryCromerrWidget('#loginButton').unbind('click').click(function (evt) {
            evt.preventDefault();
            loginFunction();
        });

        $jQueryCromerrWidget('#password').unbind('keypress').keypress(function (evt) {
            if (evt.which === 13) {
                evt.preventDefault();
                loginFunction();
            }
        });

        $jQueryCromerrWidget('#loginForm').fadeIn();

        if (config.widgetParams.userId != null) {
            setTimeout(function () {
                $jQueryCromerrWidget('#password').blur().focus();
                setTimeout(function () {
                    $jQueryCromerrWidget('#password').blur().focus();
                }, 100);
            }, 1000);
        } else {
            setTimeout(function () {
                $jQueryCromerrWidget('#userId').focus();
            }, 1000);
        }
    }

    function autoAuthenticate() {
        $jQueryCromerrWidget('#loginForm').hide();
        $jQueryCromerrWidget('#autoAuth').fadeIn();
        $jQueryCromerrWidget('#authFormLoadingIcon').show();

        authenticate(baseUrl + '/CromerrScripts/AutoAuthenticateUser');
    }

    function handleOIDCUser() {
        $jQueryCromerrWidget('#loginForm').hide();
        sign();
    }

    function startAuthentication() {
        if (secondFactorConfig.DataflowRoleAuthenticationMode === 'Automatic') {
            autoAuthenticate();
        }
        else if (isOIDCMigratedUser) {
            handleOIDCUser();
        }
        else {
            goToLoginForm();
        }
    }

    function goToVerificationForm(result) {
        $jQueryCromerrWidget('#autoVerify').hide();

        $jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch]').unbind('click').click(function () {
            // ReSharper disable once CssBrowserCompatibility
            secondFactorSwitchFunction($jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch]:visible:checked').val());
        });

        $jQueryCromerrWidget('#answerButton').unbind('click').click(function (evt) {
            evt.preventDefault();
            securityQuestionFunction();
        });

        $jQueryCromerrWidget('#answer').unbind('keypress').keypress(function (evt) {
            if (evt.which === 13) {
                evt.preventDefault();
                securityQuestionFunction();
            }
        });

        $jQueryCromerrWidget('#mobileSendButton').unbind('click').click(function (evt) {
            evt.preventDefault();
            mobileSendFunction();
        });

        $jQueryCromerrWidget('#mobileValidateButton').unbind('click').click(function (evt) {
            evt.preventDefault();
            mobileValidateFunction();
        });

        $jQueryCromerrWidget('#mobileCode').unbind('keypress').keypress(function (evt) {
            if (evt.which === 13) {
                evt.preventDefault();
                mobileValidateFunction();
            }
        });

        $jQueryCromerrWidget('#pivcardValidateButton').unbind('click').click(function (evt) {
            evt.preventDefault();
            pivcardValidateFunction();
        });

        // Prepare second factor panel for first-time display
        if (result != null && result != undefined) {
            prepareSecondFactorPanel(result);
        }
    }

    function prepareSecondFactorPanel(result, methodToShow) {
        // Process 20-5-1 Question Panel
        if (secondFactorConfig.DataflowRoleSignatureQuestions !== 'NotUsed' && secondFactorConfig.UserHasQuestion) {
            $jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch][value="Question"]').parent('label').show();
            $jQueryCromerrWidget('#question').html(result.Data.Question.text);
            $jQueryCromerrWidget('#questionId').val(result.Data.Question.questionId);
        }
        else {
            $jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch][value="Question"]').parent('label').hide();
        }

        // Process SMS/Mobile Panel
        if (secondFactorConfig.DataflowRoleMobileCode !== 'NotUsed' && secondFactorConfig.UserHasMobile) {
            $jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch][value="Mobile"]').parent('label').show();
            $jQueryCromerrWidget.each(result.Data.MobileList, function (i, mobile) {
                $jQueryCromerrWidget('select.mobileList').append($jQueryCromerrWidget('<option>', {
                    value: mobile.MobilePhoneDigitsOnly,
                    text: mobile.MobilePhoneRedacted
                }));
            });
            if (result.Data.MobileList.length > 1) {
                $jQueryCromerrWidget('span#mobile').html('');
                $jQueryCromerrWidget('span#mobile').hide();
            }
            else {
                $jQueryCromerrWidget('span#mobile').show();
                $jQueryCromerrWidget('span#mobile').html(result.Data.MobileList[0].MobilePhoneRedacted);
                $jQueryCromerrWidget('select.mobileList').hide();
            }
        }
        else {
            $jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch][value="Mobile"]').parent('label').hide();
        }

        if (secondFactorConfig.DataflowRoleDefaultMethod !== 'PIVCard') {
            $jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch][value="PIVCard"]').parent('label').hide();
        } else {
            $jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch][value="PIVCard"]').parent('label').show();
        }

        if (secondFactorConfig.DataflowRoleDefaultIsMandatory === true) {
            $jQueryCromerrWidget('p.secondFactorSwitch').hide();
        } else {
            $jQueryCromerrWidget('p.secondFactorSwitch').show();
            var secondFactorSwitchCount = $jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch]:visible').length;
            if (secondFactorSwitchCount <= 1) {
                $jQueryCromerrWidget('p.secondFactorSwitch').hide();
            }
        }

        // Unbinding password keypress
        $jQueryCromerrWidget('#password').unbind('keypress');

        // Show appropriate second factor panel depending on dataflow's default method
        if ((methodToShow === 'Question' && secondFactorConfig.UserHasQuestion) || (!methodToShow && secondFactorConfig.DataflowRoleDefaultMethod === 'Question')) {
            $jQueryCromerrWidget('#questionForm').fadeIn();
            $jQueryCromerrWidget('.fancybox-inner').scrollTop($jQueryCromerrWidget('#questionForm').offset().top);
            $jQueryCromerrWidget('#answer').focus();
        }
        else if ((methodToShow === 'Mobile' && secondFactorConfig.UserHasMobile) || (!methodToShow && secondFactorConfig.DataflowRoleDefaultMethod === 'Mobile')) {
            $jQueryCromerrWidget('#mobileForm').fadeIn();
            $jQueryCromerrWidget('.fancybox-inner').scrollTop($jQueryCromerrWidget('#mobileForm').offset().top);
            $jQueryCromerrWidget('#mobileSendButton').focus();
        }
        else if (methodToShow === 'PIVCard' || (!methodToShow && secondFactorConfig.DataflowRoleDefaultMethod === 'PIVCard')) {
            $jQueryCromerrWidget('#pivcardForm').fadeIn();
            $jQueryCromerrWidget('.fancybox-inner').scrollTop($jQueryCromerrWidget('#pivcardForm').offset().top);
            $jQueryCromerrWidget('#pivcardSendButton').focus();
        }

        // When prompting user to setup another second factor method, show that method after setup is complete and user clicks continue link
        if (methodToShow === 'Question' && secondFactorConfig.UserHasQuestion) {
            secondFactorSwitchFunction(methodToShow);
        }
        else if (methodToShow === 'Mobile' && secondFactorConfig.UserHasMobile) {
            secondFactorSwitchFunction(methodToShow);
        }
        else {
            $jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch][value="' + secondFactorConfig.DataflowRoleDefaultMethod + '"]').attr('checked', true);
            $jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch][value!="' + secondFactorConfig.DataflowRoleDefaultMethod + '"]').attr('checked', false);
        }
    }

    function autoVerify() {
        $jQueryCromerrWidget('p.secondFactorSwitch,#questionForm,#mobileForm,#pivcardForm').hide();
        $jQueryCromerrWidget('#autoVerify').fadeIn();

        var data = {
            activityId: $jQueryCromerrWidget('#activityId').val(),
            userRoleId: config.widgetParams.userRoleId
        }

        $jQueryCromerrWidget.ajax({
            url: baseUrl + '/CromerrScripts/AutoVerifyUser',
            data: data,
            dataType: 'json',
            method: 'POST',
            type: 'POST',
            success: function (autoVerifyResult) {
                if (autoVerifyResult.Status === 'success') {
                    if (autoVerifyResult.Data.method === 'PIVCard') {
                        $jQueryCromerrWidget.ajax({
                            url: baseUrl + '/PivCard/GetPivCardStatus',
                            data: data,
                            dataType: 'json',
                            method: 'POST',
                            type: 'POST',
                            success: function (result) {
                                if (result.Status === 'success' && result.Data.Success === true) {
                                    verify(autoVerifyResult.Data.url, autoVerifyResult.Data.data, autoVerifyResult.Data.method);
                                } else {
                                    $jQueryCromerrWidget('#pivcardValidateWait').attr('src', loadingIconPath).hide();
                                    $jQueryCromerrWidget('#verifyResult').html(result.Data.Reason).addClass('error').show();
                                    if (secondFactorConfig.DataflowRoleVerificationMode === 'Automatic') {
                                        secondFactorConfig.DataflowRoleVerificationMode = 'Default';
                                    }
                                    goToVerificationForm();
                                }
                            },
                            error: function (jqXhr, textStatus, errorThrown) {
                                config.error.call(this, errorThrown);
                            }
                        });
                    } else {
                        verify(autoVerifyResult.Data.url, autoVerifyResult.Data.data, autoVerifyResult.Data.method);
                    }
                } else {
                    if (secondFactorConfig.DataflowRoleVerificationMode === 'Automatic') {
                        secondFactorConfig.DataflowRoleVerificationMode = 'Default';
                    }
                    goToVerificationForm();
                }
            },
            error: function (jqXhr, textStatus, errorThrown) {
                config.error.call(this, errorThrown);
            }
        });
    }

    function verify(url, data, method) {
        $('#answerButton, #mobileValidateButton, #pivcardValidateButton').attr('disabled', 'disabled');
        $jQueryCromerrWidget.ajax({
            url: url,
            data: data,
            dataType: 'json',
            method: 'POST',
            type: 'POST',
            success: function (result) {
                $('#answerButton, #mobileValidateButton, #pivcardValidateButton').removeAttr('disabled');
                answerValidationCallback(result, method);
            },
            error: function (jqXhr, textStatus, errorThrown) {
                $('#answerButton, #mobileValidateButton, #pivcardValidateButton').removeAttr('disabled');
                $jQueryCromerrWidget('#answerWait,#mobileValidateWait').hide();
                config.error.call(this, errorThrown);
            }
        });
    }

    function startVerification(result) {
        $jQueryCromerrWidget('#verifyPanel').fadeIn();
        if (secondFactorConfig.DataflowRoleVerificationMode === 'Automatic') {
            autoVerify();
        } else {
            goToVerificationForm(result);
        }
    }

    function goToSignForm() {
        $jQueryCromerrWidget('#autoSign').hide();
        $jQueryCromerrWidget('#signForm').fadeIn();
        $jQueryCromerrWidget('#signSubmitContainer').html('<input type="button" tabindex="1012" value="Sign" class="button" id="signSubmit">');

        if (config.widgetParams.enablePassphrase !== null && config.widgetParams.enablePassphrase === true) {
            $jQueryCromerrWidget('#passphraseField').focus();
        } else {
            $jQueryCromerrWidget('#signSubmit').focus();
        }

        $jQueryCromerrWidget('.fancybox-inner').scrollTop($jQueryCromerrWidget('#signPanel').offset().top);

        //Create click event only after the button has been added to the DOM
        $jQueryCromerrWidget('#signSubmit').unbind('keydown').keydown(function (event) {
            if (!event.shiftKey && event.keyCode === 9) {
                event.preventDefault();
            }
        });

        $jQueryCromerrWidget('#signSubmit').unbind('click').click(function (evt) {
            evt.preventDefault();
            if ($jQueryCromerrWidget('#passphraseDialog').css('display') !== 'none') {
                if (!$jQueryCromerrWidget('#signForm').valid()) {
                    return;
                }
            }

            $jQueryCromerrWidget('#signatureWait').attr('src', loadingIconPath).show();
            sign();
        });
    }

    function autoSign() {
        $jQueryCromerrWidget('#signForm').hide();
        $jQueryCromerrWidget('#autoSign').fadeIn();

        var data = {
            activityId: $jQueryCromerrWidget('#activityId').val(),
            userRoleId: config.widgetParams.userRoleId
        }

        $jQueryCromerrWidget.ajax({
            url: baseUrl + '/CromerrScripts/AutoSignUser',
            data: data,
            dataType: 'json',
            method: 'POST',
            type: 'POST',
            success: function (result) {
                if (result.Status === 'success') {
                    sign();
                } else {
                    if (secondFactorConfig.DataflowRoleSignatureMode === 'Automatic') {
                        secondFactorConfig.DataflowRoleSignatureMode = 'Default';
                    }
                    goToSignForm();
                }
            },
            error: function (jqXhr, textStatus, errorThrown) {
                config.error.call(this, errorThrown);
            }
        });
    }

    function startSignature() {
        $jQueryCromerrWidget('#signPanel').fadeIn();
        if (secondFactorConfig.DataflowRoleSignatureMode === 'Automatic' &&
            (config.widgetParams.enablePassphrase === undefined || config.widgetParams.enablePassphrase === null || config.widgetParams.enablePassphrase !== true)) {
            autoSign();
        } else {
            goToSignForm();
        }
    }

    function sign() {
        var doc = config.widgetParams.signableDocument;

        if (doc != null && doc.url != null) {
            //If document location is provided, continue with signing document and retrieving document by location
            var url = ((doc.url.indexOf("http") == 0) || (doc.url.indexOf("https") == 0)) ? doc.url : (baseUrl + doc.url);
            var data = {
                activityId: $jQueryCromerrWidget('#activityId').val(),
                attachmentUrl: url,
                attachmentName: doc.documentName,
                userRoleId: config.widgetParams.userRoleId,
                sendEmail: config.widgetParams.sendEmail,
                tags: config.widgetParams.tags,
                acronym: config.widgetParams.dataflow
            }

            $('#signSubmit').attr('disabled', 'disabled');
            $jQueryCromerrWidget.ajax({
                url: baseUrl + '/CromerrScripts/Sign',
                data: data,
                dataType: 'json',
                method: 'POST',
                type: 'POST',
                success: function (result) {
                    $('#signSubmit').removeAttr('disabled');
                    signatureCallback(result);
                    $jQueryCromerrWidget('#signatureWait,#signFormLoadingIcon').hide();
                },
                error: function (jqXhr, textStatus, errorThrown) {
                    $('#signSubmit').removeAttr('disabled');
                    $jQueryCromerrWidget('#signatureWait,#signFormLoadingIcon').hide();
                    config.error.call(this, errorThrown);
                }
            });
        } else {
            //If no document location is provided, invoke success callback
            $('#signSubmit').attr('disabled', 'disabled');
            signAndCloseWidget();
        }
    }

    function resetWidget() {
        $jQueryCromerrWidget('#' + config.esignButtonId).unbind();
        //$jQueryCromerrWidget.cromerrWidget(config);

        //Preserve activity id
        var aId = $jQueryCromerrWidget('#activityId').val();

        //Build widget layout
        buildLayout();

        $jQueryCromerrWidget('#activityId').val(aId);

        //Set up events
        initializeEvents();
    }

    function activityIdCallback(result) {
        modalClose();
        $jQueryCromerrWidget('#activityId').val(result);
        setTimeout(function () {
            if (!isOIDCMigratedUser) {
                $jQueryCromerrWidget('#openWidgetHidden').click();
            }
            openingSignatureWidget = false;
            //Control visibility of passphrase dialog
            if (config.widgetParams.enablePassphrase !== null && config.widgetParams.enablePassphrase === true) {
                $jQueryCromerrWidget('#passphraseDialog').show();
                $jQueryCromerrWidget('#signTitle').html('Sign and Encrypt');
            } else {
                $jQueryCromerrWidget('#passphraseDialog').hide();
            }

            startAuthentication();
        }, 250);
    }

    function openWidgetModal(bypassDisclaimer) {
        $jQueryCromerrWidget('#widgetLoadingIndicator').show();
        dialogCancelled = false;
        var data = {
            userRoleId: config.widgetParams.userRoleId,
            acronym: config.widgetParams.dataflow,
            tags: config.widgetParams.tags,
            isOrganizationalUser: config.widgetParams.isOrganizationalUser
        }

        //Loop through dynamic properties to pass list to controller
        var count = 0;
        data.properties = {};
        $jQueryCromerrWidget.each(config.widgetParams.props, function (key, val) {
            if (data[key] === null || data[key] === undefined) {
                data['properties[' + count + '].Key'] = key;
                data['properties[' + count + '].Value'] = val;
                count++;
            }
        });


        if (bypassDisclaimer) {
            var overlayCss = {
                backgroundColor: '#777777',
                cursor: 'auto',
                opacity: '0.7'
            };
        }

        if (isOIDCMigratedUser) {
            getOIDCActivity(bypassDisclaimer);
        } else {
            $jQueryCromerrWidget.ajax({
                url: baseUrl + '/CromerrScripts/GetActivityId',
                data: data,
                dataType: 'json',
                method: 'POST',
                type: 'POST',
                async: false,
                success: function (result) {
                    if (bypassDisclaimer) {
                        $.unblockUI();
                    }
                    if (result.Status === 'success') {
                        activityIdCallback(result.Data);
                    } else {
                        modalClose();
                        config.error.call(this, result.Message);
                    }
                },
                error: function (jqXhr, textStatus, errorThrown) {
                    config.error.call(this, errorThrown);
                }
            });
        }
    }

    function validationLoadedCallback() {
        $jQueryCromerrWidget('#loginForm').validate({
            rules: {
                password: { required: true },
                userId: { required: true }
            },
            errorElement: "p",
            errorClass: "error",
            errorPlacement: function (error, element) {
                element.after(error);
            }
        });

        $jQueryCromerrWidget('#questionForm').validate({
            rules: {
                answer: { required: true }
            },
            errorElement: "p",
            errorClass: "error",
            errorPlacement: function (error, element) {
                element.after(error);
            }
        });

        $jQueryCromerrWidget.validator.addMethod("passphraseMatch", function (value) {
            var passphrase = $jQueryCromerrWidget('#passphraseField').val();
            passphrase = passphrase.replace(/^\s+|\s+$jQueryCromerrWidget/g, '');
            var passphraseConfirm = value.replace(/^\s+|\s+$jQueryCromerrWidget/g, '');

            return passphrase === passphraseConfirm;
        }, "Passphrases do not match.");

        $jQueryCromerrWidget('#signForm').validate({
            rules: {
                passphraseField: { required: true },
                //confirmPassphrase: { required: true, passphraseMatch: true }
                confirmPassphrase: { required: true, equalTo: '#passphraseField' }
            },
            errorElement: "p",
            errorClass: "error",
            errorPlacement: function (error, element) {
                element.after(error);
            }
        });
    }

    function authenticate(url) {
        var data = {
            activityId: $jQueryCromerrWidget('#activityId').val(),
            'user.userId': $jQueryCromerrWidget('#userId').val(),
            'user.password': $jQueryCromerrWidget('#password').val(),
            userRoleId: config.widgetParams.userRoleId,
            tags: config.widgetParams.tags,
            acronym: config.widgetParams.dataflow
        }

        //Loop through dynamic properties to pass list to controller
        var count = 0;
        $jQueryCromerrWidget.each(config.widgetParams.props, function (key, val) {
            if (data[key] === null || data[key] === undefined) {
                data['properties[' + count + '].Key'] = key;
                data['properties[' + count + '].Value'] = val;
                count++;
            }
        });

        $('#loginButton').attr('disabled', 'disabled');
        $jQueryCromerrWidget.ajax({
            url: url,
            data: data,
            dataType: 'json',
            method: 'POST',
            type: 'POST',
            success: function (result) {
                $('#loginButton').removeAttr('disabled');
                $jQueryCromerrWidget('#loginButton,#authFormLoadingIcon,#loginWait').hide();
                authenticationCallback(result);
            },
            error: function (jqXhr, textStatus, errorThrown) {
                $('#loginButton').removeAttr('disabled');
                $jQueryCromerrWidget('#loginWait,#authFormLoadingIcon').hide();
                config.error.call(this, errorThrown);
            }
        });
    }

    function authenticationCallback(result) {
        if (result.Status === 'success') {
            $jQueryCromerrWidget('#autoAuthStatus').html('Authenticated');
            $jQueryCromerrWidget('#password,#userid').prop("readonly", true);
            $jQueryCromerrWidget('#authResult').html('Welcome ' + result.Data.User.FirstName + ' ' + result.Data.User.LastName).fadeIn()
                .addClass('success').removeClass('error');

            secondFactorConfig = $jQueryCromerrWidget.extend({}, secondFactorConfig, result.Data.SecondFactorConfig);

            startVerification(result);
        } else {
            $jQueryCromerrWidget('#authResult').html(result.Data.description).addClass('error').show();
            if (secondFactorConfig.DataflowRoleAuthenticationMode === 'Automatic') {
                secondFactorConfig.DataflowRoleAuthenticationMode = 'Default';
            }
            goToLoginForm();
        }
    }

    function readyCallback(){
        if(typeof(config.ready) == "function"){
            config.ready.call(this);
        }
    }

    function signAndCloseWidget(sigConfirmation) {
        $jQueryCromerrWidget('#signatureWait,#signFormLoadingIcon').hide();
        $jQueryCromerrWidget('#authPanel,#verifyPanel').fadeOut();
        $jQueryCromerrWidget('#signPanel').fadeOut(function () {
            widgetCancelled = false;
            modalClose();

            var overlayCss = {
                backgroundColor: '#777777',
                cursor: 'auto',
                opacity: '0.7'
            };

            config.success.call(this, { activityId: $jQueryCromerrWidget('#activityId').val(), submissionId: sigConfirmation, passphrase: $jQueryCromerrWidget('#passphraseField').val() });
        });
    }

    function signatureCallback(result) {
        if (result.Status === 'success') {
            signAndCloseWidget(result.Data);
        } else {
            config.error.call(this, result.Message);
        }
    }

    function answerValidationCallback(result, method) {
        var resultSuccessMessage = '';
        $jQueryCromerrWidget('#answerWait,#mobileValidateWait,#pivcardValidateWait').hide();
        if (method === 'Question') {
            resultSuccessMessage = 'Correct Answer';
        }
        else if (method === 'Mobile') {
            resultSuccessMessage = 'PIN Verified';
        } else if (method === 'PIVCard') {
            resultSuccessMessage = 'PIV Card Verified';
        }

        if (result.Status === 'success' && result.Data === true) {
            $jQueryCromerrWidget('#autoVerifyStatus').html('Verified');
            $jQueryCromerrWidget('#answerButton,#mobileSendButton, #mobileValidateButton,p.secondFactorSwitch,#answerWait,#mobileValidateWait').hide();
            //Unbinding second factor keypress
            $jQueryCromerrWidget('#answer,#mobileCode').unbind('keypress');
            $jQueryCromerrWidget('#verifyResult').html(resultSuccessMessage).fadeIn().addClass('success').removeClass('error');

            startSignature();
        } else {
            $jQueryCromerrWidget('#verifyResult').html(result.Data.description);

            if (result.Message && result.Message.indexOf('E_WrongAnswer') == 0) {
                // If mobile (SMS) is configured for this role, prompt user to setup nobile
                // Link in prompt can be configured, see CromerrScriptsController#ValidateAnswer
                var secondFactorPrompt = config.widgetParams.secondFactorPrompt;
                var methodToShow = null;
                if (method === 'Question') {
                    if (secondFactorConfig.DataflowRoleMobileCode !== 'NotUsed' && secondFactorConfig.UserHasMobile == false) {
                        var prompt = result.Items[0].Value;
                        if (prompt) {
                            $jQueryCromerrWidget('#verifyResult').html($jQueryCromerrWidget('#verifyResult').html() + ' ' + prompt);
                            methodToShow = 'Mobile';
                        }
                    }
                }
                if (methodToShow) {
                    $jQueryCromerrWidget('#secondFactorSetup').unbind('click').click(function (evt) {
                        evt.preventDefault();
                        window.open($jQueryCromerrWidget('#secondFactorSetup').attr('src'), '_blank');
                    });
                    $jQueryCromerrWidget('#secondFactorPromptContinue').unbind('click').click(function (evt) {
                        evt.preventDefault();

                        var data = {
                            activityId: $jQueryCromerrWidget('#activityId').val(),
                            userRoleId: config.widgetParams.userRoleId
                        }

                        $jQueryCromerrWidget('#verifyRefreshWait').attr('src', loadingIconPath).show();
                        $jQueryCromerrWidget.ajax({
                            url: baseUrl + '/CromerrScripts/GetSecondFactorPanel',
                            data: data,
                            dataType: 'json',
                            method: 'POST',
                            type: 'POST',
                            success: function (result) {
                                $jQueryCromerrWidget('#verifyRefreshWait').hide();
                                $jQueryCromerrWidget('#verifyResult').html('');
                                if (result != null && result != undefined) {
                                    secondFactorConfig = $jQueryCromerrWidget.extend({}, secondFactorConfig, result.Data.SecondFactorConfig);
                                    prepareSecondFactorPanel(result, methodToShow);
                                }
                                else {
                                    config.error.call(this, errorThrown);
                                }
                            },
                            error: function (jqXhr, textStatus, errorThrown) {
                                $jQueryCromerrWidget('#verifyRefreshWait').hide();
                                config.error.call(this, errorThrown);
                            }
                        });
                    });
                }
            }

            $jQueryCromerrWidget('#verifyResult').addClass('error').show();
            if (secondFactorConfig.DataflowRoleVerificationMode === 'Automatic') {
                secondFactorConfig.DataflowRoleVerificationMode = 'Default';
            }
            goToVerificationForm();
        }
    }

    function getWidgetContent() {
        var content = '\
        <div class="modal" id="cromerrWidgetModal" tabindex="-1" role="dialog" aria-hidden="true">\
        <div class="modal-dialog modal-dialog-centered" role="document">\
        <div class="modal-content">\
            <div class="modal-header">\
                <h5 class="modal-title">eSignature Widget</h5>\
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">\
                    <span aria-hidden="true">&times;</span>\
                </button>\
            </div>\
            <div class="modal-body">\
            <div id="cromerrWidgetContainer">\
                <div class="page-container">\
                    <div class="main">\
                        <div class="main-content">\
                            <div style="display: none" class="column1-unit" id="eSignLoadingPanel">\
                                <h2>\
                                    eSignature is loading. Please wait...</h2>\
                                <img alt="Loading" src="" class="center">\
                            </div>\
                            <div id="eSignPanel">\
                                <div class="column3-unit-left" id="authPanel">\
                                    <h2>\
                                        1. <span id="authTitle">Authentication</span></h2>\
                                    <div class="loginform">\
                                        <div id="autoAuth">\
                                            <p id="autoAuthStatus">Authenticating...<br/><img id="authFormLoadingIcon" src="' + loadingIconPath + '"></p>\
                                        </div>\
                                        <form onsubmit="return false;" action="#" method="post" id="loginForm" autocomplete="off">\
                                        <p>Log into CDX</p>\
                                        <fieldset>\
                                            <p>\
                                                <label class="top" for="userId">\
                                                    User:</label>\
                                                <br>\
                                                <span class="text">\
                                                    <input type="text" class="field required" value="" id="userId"></span>\
                                                <input type="hidden" id="activityId">\
                                            </p>\
                                            <p>\
                                                <label class="top" for="password">\
                                                    Password:</label>\
                                                <br>\
                                                <input style="display: none" type="text" name="autocompletedisable_userId"/>\
                                                <input style="display: none" type="password" name="autocompletedisable_password"/>\
                                                <input type="password" value="" class="field required" tabindex="1002" id="password"\
                                                    name="password" readonly="readonly" onfocus="this.removeAttribute(\'readonly\');">\
                                                <input style="display: none" type="text" name="autocompletedisable_userId"/>\
                                                <input style="display: none" type="password" name="autocompletedisable_password"/>\
                                            </p>\
                                            <p>\
                                                <label for="ShowPassword" style="display:inline">Show Password</label>\
                                                <input type="checkbox" id="ShowPassword" class="ShowPassword" />\
                                            </p>\
                                            <p id="loginSubmit">\
                                                <input type="button" tabindex="1003" value="Login" class="button" id="loginButton">\
                                                <img alt="Verifying Authentication" src="" style="display: none" id="loginWait">\
                                            </p>\
                                        </fieldset>\
                                        </form>\
                                        <p class="result" style="display: none" id="authResult">\
                                    </div>\
                                </div>\
                                <div style="display: none" id="verifyPanel" class="column3-unit-middle secondFactorPanel">\
                                    <h2>\
                                        2. <span id="verifyTitle">Verification</span></h2>\
                                    <div class="loginform">\
                                        <div id="autoVerify">\
                                            <p id="autoVerifyStatus">Verifying...<br/><img id="verifyFormLoadingIcon" src="' + loadingIconPath + '"></p>\
                                        </div>\
                                        <p class="secondFactorSwitch">\
                                            <label for="radioQQ" style="font-weight: normal">\
                                                <input type="radio" id="radioQQ" name="secondFactorSwitch" checked="checked" value="Question" data-form="questionForm" tabIndex="1008"/>\
                                                Answer Secret Question<br/>\
                                            </label>\
                                            <label for="radioQM" style="font-weight: normal">\
                                            <input type="radio" id="radioQM" name="secondFactorSwitch" value="Mobile" data-form="mobileForm" tabIndex="1008"/>\
                                                Send Text Message<br/>\
                                            </label>\
                                            <label for="radioQP" style="font-weight: normal">\
                                            <input type="radio" id="radioQP" name="secondFactorSwitch" value="PIVCard" data-form="pivcardForm" tabIndex="1008"/>\
                                                Use PIV Card<br/>\
                                            </label>\
                                        </p>\
                                        <form onsubmit="return false;" action="" method="post" id="questionForm" autocomplete="off">\
                                        <fieldset>\
                                            <p>\
                                                <label class="top" for="questionId">\
                                                    Question:</label>\
                                                <input type="hidden" id="questionId">\
                                                <br>\
                                                <span class="text" id="question"></span>\
                                            </p>\
                                            <p>\
                                                <label class="top" for="answer">\
                                                    Answer:</label>\
                                                <br>\
                                                <input type="password" class="field required" tabindex="1004" id="answer" name="answer">\
                                            </p>\
                                            <p>\
                                                <label for="ShowAnswer" style="display:inline">Show Answer</label>\
                                                <input type="checkbox" id="ShowAnswer" class="ShowPassword" />\
                                            </p>\
                                            <p id="questionSubmit">\
                                                <input type="button" tabindex="1005" value="Answer" class="button" id="answerButton">\
                                                <img alt="Verifying Secret Answer" src="" style="display: none" id="answerWait">\
                                            </p>\
                                        </fieldset>\
                                        </form>\
                                        <form onsubmit="return false;" action="" method="post" id="mobileForm" autocomplete="off">\
                                        <fieldset>\
                                            <p>\
                                                <label class="top" style="width: 225px">\
                                                    Text message will be sent to:</label>\
                                                <br>\
                                                <span class="text" id="mobile"></span>\
                                                <select class="field mobileList" tabIndex="1008"></select>\
                                                <br>\
                                                Message and data rates may apply.\
                                            </p>\
                                            <p>\
                                                <input type="button" tabindex="1004" value="Send" class="button" id="mobileSendButton">\
                                                <img alt="Sending PIN Number" src="" style="display: none" id="mobileSendWait">\
                                            </p>\
                                            <p class="mobileValidate" style="display: none">\
                                                <br>\
                                                <label class="top" for="mobileCode" style="width: 175px">\
                                                    Enter PIN below:</label>\
                                                <br>\
                                                <input type="text" class="field required" tabindex="1005" id="mobileCode" name="mobileCode" maxlength="6">\
                                            </p>\
                                            <p class="mobileValidate" style="display: none">\
                                                <input type="button" tabindex="1006" value="Verify" class="button" id="mobileValidateButton">\
                                                <img alt="Verifying PIN Number" src="" style="display: none" id="mobileValidateWait">\
                                            </p>\
                                        </fieldset>\
                                        </form>\
                                        <form onsubmit="return false;" action="" method="post" id="pivcardForm" autocomplete="off">\
                                        <p>Insert your PIV Card</p>\
                                        <fieldset>\
                                            <p class="pivcardValidate">\
                                                <input type="button" tabindex="1006" value="Verify" class="button" id="pivcardValidateButton">\
                                                <img alt="Verifying PIV Card" src="" style="display: none" id="pivcardValidateWait">\
                                            </p>\
                                        </fieldset>\
                                        </form>\
                                        <p class="result" style="display: none" id="verifyResult">\
                                        </p>\
                                        <img alt="Refreshing Verification" src="" style="display: none" id="verifyRefreshWait">\
                                    </div>\
                                </div>\
                                <div style="display: none" id="signPanel" class="column3-unit-right">\
                                    <h2>\
                                        3. <span id="signTitle">Sign File</span></h2>\
                                    <div class="loginform">\
                                        <div id="autoSign">\
                                            <p id="autoSignStatus">Signing...<br/><img id="signFormLoadingIcon" src="' + loadingIconPath + '"></p>\
                                        </div>\
                                        <form onsubmit="return false;" action="" method="post" id="signForm" autocomplete="off">\
                                        <fieldset>\
                                            <span style="display: none" id="passphraseDialog">\
                                                <input style="display: none" type="text" name="autocompletedisable_userId"/>\
                                                <input style="display: none" type="password" name="autocompletedisable_password"/>\
                                                <p>\
                                                    <label class="top" for="passphraseField">\
                                                        Passphrase:</label><input type="password" class="field required" tabindex="1010"\
                                                            id="passphraseField" name="passphraseField" readonly="readonly" onfocus="this.removeAttribute(\'readonly\');"></p>\
                                                <p>\
                                                    <label class="top" for="confirmPassphrase">\
                                                        Re-enter:</label><input type="password" class="field required" tabindex="1011" id="confirmPassphrase"\
                                                            name="confirmPassphrase" equalto="#passphraseField" readonly="readonly" onfocus="this.removeAttribute(\'readonly\');"></p>\
                                                <input style="display: none" type="text" name="autocompletedisable_userId"/>\
                                                <input style="display: none" type="password" name="autocompletedisable_password"/>\
                                            </span>\
                                            <p>\
                                                <span id="signSubmitContainer"></span>\
                                                <img alt="Processing Signature" src="" style="display: none" id="signatureWait">\
                                            </p>\
                                        </fieldset>\
                                        </form>\
                                        <p class="result" style="display: none" id="signResult">\
                                        </p>\
                                    </div>\
                                </div>\
                            </div>\
                        </div>\
                    </div>\
                </div>\
            </div>\
            </div>\
        </div>\
        </div>\
        </div>\
        ';

        return content;
    }

    function loginFunction() {
        if (!$jQueryCromerrWidget('#loginForm').valid()) {
            return;
        }

        $jQueryCromerrWidget('#loginWait').attr('src', loadingIconPath).show();

        authenticate(baseUrl + '/CromerrScripts/AuthenticateUser');
    }

    function secondFactorSwitchFunction(val) {
        $jQueryCromerrWidget('#questionForm,#mobileForm,#pivcardForm').hide();

        $jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch][value="' + val + '"]').prop('checked', 'checked');
        $jQueryCromerrWidget('#' + $jQueryCromerrWidget('input[type=radio][name=secondFactorSwitch][value="' + val + '"]').attr('data-form')).show();
    }

    // SECURITY QUESTIONS FUNCTIONALITY
    function securityQuestionFunction() {
        if (!$jQueryCromerrWidget('#questionForm').valid()) {
            return;
        }

        $jQueryCromerrWidget('#answerWait').attr('src', loadingIconPath).show();

        var data = {
            activityId: $jQueryCromerrWidget('#activityId').val(),
            userId: $jQueryCromerrWidget('#userId').val(),
            userRoleId: config.widgetParams.userRoleId,
            questionId: $jQueryCromerrWidget('#questionId').val(),
            answer: $jQueryCromerrWidget('#answer').val()
        }

        verify(baseUrl + '/CromerrScripts/ValidateAnswer', data, 'Question');
    }

    // SMS OPTIONS FUNCTIONALITY
    function mobileSendFunction() {
        $jQueryCromerrWidget('#mobileSendWait').attr('src', loadingIconPath).show();

        var data = {
            activityId: $jQueryCromerrWidget('#activityId').val(),
            userId: $jQueryCromerrWidget('#userId').val(),
            mobilePhone: ($jQueryCromerrWidget('select.mobileList').length > 0 ? $jQueryCromerrWidget('select.mobileList').val() : '')
        }

        $('#mobileSendButton').attr('disabled', 'disabled');
        $jQueryCromerrWidget.ajax({
            url: baseUrl + '/CromerrScripts/SendSecretCode',
            data: data,
            dataType: 'json',
            method: 'POST',
            type: 'POST',
            success: function () {
                $('#mobileSendButton').removeAttr('disabled');
                $jQueryCromerrWidget('#mobileForm .mobileValidate').show();
                $jQueryCromerrWidget('#mobileCode').val('');
                $jQueryCromerrWidget('#mobileCode').focus();
                $jQueryCromerrWidget('#verifyResult').html('');
                $jQueryCromerrWidget('#mobileSendWait').hide();
            },
            error: function (jqXhr, textStatus, errorThrown) {
                $('#mobileSendButton').removeAttr('disabled');
                $jQueryCromerrWidget('#mobileSendWait').hide();
                config.error.call(this, errorThrown);
            }
        });
    }

    function mobileValidateFunction() {
        $jQueryCromerrWidget('#mobileValidateWait').attr('src', loadingIconPath).show();

        var data = {
            activityId: $jQueryCromerrWidget('#activityId').val(),
            userId: $jQueryCromerrWidget('#userId').val(),
            userRoleId: config.widgetParams.userRoleId,
            code: $jQueryCromerrWidget('#mobileCode').val()
        }

        verify(baseUrl + '/CromerrScripts/ValidateSecretCode', data, 'Mobile');
    }

    function pivcardValidateFunction() {
        $jQueryCromerrWidget('#pivcardValidateWait').attr('src', loadingIconPath).show();

        var data = {
            activityId: $jQueryCromerrWidget('#activityId').val(),
            userRoleId: config.widgetParams.userRoleId
        }

        $jQueryCromerrWidget.ajax({
            url: baseUrl + '/PivCard/GetPivCardStatus',
            data: data,
            dataType: 'json',
            method: 'POST',
            type: 'POST',
            success: function (result) {
                if (result.Status === 'success' && result.Data.Success === true) {
                    verify(baseUrl + '/CromerrScripts/ValidatePivCard', data, 'PIVCard');
                } else {
                    $jQueryCromerrWidget('#pivcardValidateWait').attr('src', loadingIconPath).hide();
                    $jQueryCromerrWidget('#verifyResult').html(result.Data.Reason).addClass('error').show();
                }
            },
            error: function (jqXhr, textStatus, errorThrown) {
                config.error.call(this, errorThrown);
            }
        });
    }

    function initializeEvents() {
        function eSignButtonClickEventHandler(evt) {
            evt.preventDefault();
            $jQueryCromerrWidget('#widgetLoadingIndicator').hide();

            if (config.widgetParams.suppressDisclaimer !== null && config.widgetParams.suppressDisclaimer === true) {
                openWidgetModal(true);
            } else {
                $jQueryCromerrWidget('#openDisclaimerHidden').click();
            }
        }

        $jQueryCromerrWidget('#' + config.esignButtonId).unbind('click', eSignButtonClickEventHandler).click(eSignButtonClickEventHandler);

        $jQueryCromerrWidget('#disclaimerAccept').unbind('click').click(function (evt) {
            evt.preventDefault();
            openWidgetModal(false);
            openingSignatureWidget = true;
        });

        $jQueryCromerrWidget('#disclaimerDecline').unbind('click').click(function (evt) {
            evt.preventDefault();
            dialogCancelled = true;
            modalClose();
        });

        $jQueryCromerrWidget('#cromerrWidgetContainer input[type="button"], #disclaimerContainer #disclaimerDecline').unbind('keydown').keydown(function (evt) {
            if (!evt.shiftKey && evt.keyCode === 9) {
                evt.preventDefault();
            }
        });

        $jQueryCromerrWidget('#ShowPassword').unbind('click').click(function (evt) {
            if ($jQueryCromerrWidget('#ShowPassword').prop('checked') == true) {
                $jQueryCromerrWidget('#password').prop('type', 'text');
            }
            else {
                $jQueryCromerrWidget('#password').prop('type', 'password');
            }
        });

        $jQueryCromerrWidget('#ShowAnswer').unbind('click').click(function (evt) {
            if ($jQueryCromerrWidget('#ShowAnswer').prop('checked') == true) {
                $jQueryCromerrWidget('#answer').prop('type', 'text');
            }
            else {
                $jQueryCromerrWidget('#answer').prop('type', 'password');
            }
        });

        $jQueryCromerrWidget('#disclaimerModal').on('shown.bs.modal', function (e) {
            $jQueryCromerrWidget('#disclaimerAccept').focus();
        });
        $jQueryCromerrWidget('#disclaimerModal').on('hidden.bs.modal', function (e) {
            var resetOnCancel = config.widgetParams.resetOnCancel === undefined || config.widgetParams.resetOnCancel === null || config.widgetParams.resetOnCancel === true;
            if (resetOnCancel) {
                resetWidget();
            }
            if (!openingSignatureWidget) {
                if (dialogCancelled) {
                    return config.cancel.call();
                }
            }
        });

        $jQueryCromerrWidget('#cromerrWidgetModal').on('hidden.bs.modal', function (e) {
            var resetOnCancel = config.widgetParams.resetOnCancel === undefined || config.widgetParams.resetOnCancel === null || config.widgetParams.resetOnCancel === true;
            if (resetOnCancel) {
                resetWidget();
            }
            if (widgetCancelled) {
                return config.cancel.call();
            }
        });
    }

    function buildLayout() {
        if ($jQueryCromerrWidget('#cromerrWidgetModal').length > 0) {
            $jQueryCromerrWidget('#cromerrWidgetModal').remove();
        }

        if ($jQueryCromerrWidget('#disclaimerModal').length > 0) {
            $jQueryCromerrWidget('#disclaimerModal').remove();
        }

        var content = getWidgetContent();
        var dialogBegin = '<div class="modal" id="disclaimerModal" tabindex="-1" role="dialog" aria-hidden="true">' +
            '<div class="modal-dialog modal-dialog-centered" role="document">' +
            '<div class="modal-content">' +
            '<div class="modal-body">' +
            '<div style="max-width: 400px;" id="disclaimerContainer"><div id="disclaimerContent" style="overflow: auto; padding: 1px;"><font>';
        var dialogBody = 'I certify, under penalty of law that the information provided in this document is, to the best of my knowledge and belief, true, accurate, and complete.\
            I am aware that there are significant penalties for submitting false information, including the possibility of fines and imprisonment for knowing violations.';
        var dialogClose = '</font></div><div style="text-align: center; margin-top: 30px;">\
            <span><img id="widgetLoadingIndicator" src="' + baseUrl + '/Content/CromerrWidget/images/loading.gif" alt="Loading eSignature Widget" style="display:none; margin-bottom:15px;"/></span>\
            <br/><input type="button" tabindex="990" id="disclaimerAccept" value="Accept" class="button">&nbsp;<input type="button" tabindex="991" id="disclaimerDecline" value="Decline" class="button">\
            </div></div>\
            </div></div></div></div>';

        if (config.widgetParams.disclaimerText !== null && config.widgetParams.disclaimerText !== undefined && config.widgetParams.disclaimerText !== '') {
            dialogBody = config.widgetParams.disclaimerText;
        }

        var dialog = dialogBegin + dialogBody + dialogClose;

        $jQueryCromerrWidget('#cromerrWidgetAppendHolder').append(content);
        $jQueryCromerrWidget('#cromerrWidgetAppendHolder').append(dialog);

        if (config.widgetParams.userId != null) {
            var span = '<span class="text" id="prepopulatedUserInfo">' + config.widgetParams.userId + '<input type="hidden" id="userId" value="' + config.widgetParams.userId + '"></span>';
            $jQueryCromerrWidget('#userId').replaceWith(span);
        }

        $jQueryCromerrWidget('#autoAuth,#autoVerify,#autoSign,#loginForm,p.secondFactorSwitch,#questionForm,#mobileForm,#pivcardForm,#signForm').hide();
    }

    function initializeWidgetFancyBox() {
        if ($jQueryCromerrWidget('#openWidgetHidden').length <= 0) {
            $jQueryCromerrWidget('#cromerrWidgetAppendHolder').append('<a href="#" id="openWidgetHidden">Open Widget</a>');
            $jQueryCromerrWidget('#openWidgetHidden').hide();
        }

        //var fancyboxSettings = getDefaultWidgetFancyboxSettings();
        if (config.widgetModalSettings != null) {
            //console.log("KPT: widgetModalSettings = " + config.widgetModalSettings);
            ////Override default fancybox settings with options
            //fancyboxSettings = $jQueryCromerrWidget.extend({}, fancyboxSettings, config.widgetModalSettings);
        }

        $jQueryCromerrWidget("a#openWidgetHidden").unbind();
        $jQueryCromerrWidget("a#openWidgetHidden").click(function (e) {
            e.preventDefault();
            modalCreate($jQueryCromerrWidget('#cromerrWidgetModal'), 930, false);
        });
    }

    function initializeDisclaimerFancyBox() {
        if ($jQueryCromerrWidget('#openDisclaimerHidden').length <= 0) {
            $jQueryCromerrWidget('#cromerrWidgetAppendHolder').append('<a href="#" id="openDisclaimerHidden">Open Disclaimer</a>');
            $jQueryCromerrWidget('#openDisclaimerHidden').hide();
        }

        //var fancyboxSettings = getDefaultDisclaimerFancyboxSettings();
        if (config.disclaimerModalSettings != null) {
            //console.log("KPT: disclaimerModalSettings = " + config.disclaimerModalSettings);
            ////Override default fancybox settings with options
            //fancyboxSettings = $jQueryCromerrWidget.extend({}, fancyboxSettings, config.disclaimerModalSettings);            
        }

        $jQueryCromerrWidget("a#openDisclaimerHidden").unbind();
        $jQueryCromerrWidget("a#openDisclaimerHidden").click(function (e) {
            e.preventDefault();

            if (secondFactorConfig && secondFactorConfig.DataflowRoleNotSupported && secondFactorConfig.DataflowRoleNotSupported == 'true') {
                config.error.call(this, 'This role is not configured to use eSignature.');
            }
            else {
                modalCreate($jQueryCromerrWidget('#disclaimerModal'), 400, false);
            }
        });
    }

    function loadCromerrResources() {
		// Create bootstrap-styled div to append our modal HTML, etc. into, instead of just appending to body
		$jQueryCromerrWidget('body').append('<div id="cromerrWidgetAppendHolder" class="bootstrap-cromerr-widget"></div>');
		
        initializeWidgetFancyBox();
        initializeDisclaimerFancyBox();

        validationLoadedCallback();
		
        $jQueryCromerrWidget([loadingIconPath]).preload();
    }
	
	function modalCreate(selector, width, allowDismiss, iFrameHref) {
		currentWindow = selector;
		if (width != null) {
			currentWindow.find('div.modal-dialog').css('max-width', width + 'px');
		}
		if (iFrameHref != null) {
			currentWindow.find('.modal-body iframe').attr('src', iFrameHref);
			currentWindow.find('.modal-body iframe').attr('title', 'Modal window');      
		}
		$jQueryCromerrWidget('#cromerrWidgetAppendHolder').append(currentWindow);

		if (allowDismiss == false) {
			currentWindow.modal({ backdrop: 'static', keyboard: false });
		} else {
			currentWindow.modal();
		}
		
		// Needed so background fading works correctly with namespace'd bootstrap
		$jQueryCromerrWidget('div.modal-backdrop.show').filter(':last').detach().appendTo('#cromerrWidgetAppendHolder');
	};
	
	function modalClose() {
		if ($jQueryCromerrWidget('.modal:visible .modal-body iframe').length > 0) {
			// Clear iFrame content if modal window has an iFrame
			$('.modal:visible').find('.modal-body iframe').attr('src', 'about:blank');
		}
		$jQueryCromerrWidget('.modal:visible').modal('hide');
    };	

    //OIDC functions
    function storeOIDCUser(firstName, middleInitial, lastName, organizationName) {
        userData = {
            "user": {
                "firstName": firstName,
                "middleInitial": middleInitial,
                "lastName": lastName,
                "organizationName": organizationName
            }
        };
    }

    //Used For OIDC Migrated Users
    function getOIDCActivity(bypassDisclaimer) {

        var url = config.widgetParams.createActivityUrl;

        if (!url) {
            url = baseUrl + '/CromerrScripts/CreateActivity';
        }

        //deepclone user object
        var data = Object.assign({}, userData);

        if (typeof (config.widgetParams.props.activityDescription) != 'undefined') {
            data.activityDescription = config.widgetParams.props.activityDescription;
        }

        if (typeof (config.widgetParams.props.roleName) != 'undefined') {

            if (typeof (data.acl) == 'undefined') {
                data.acl = {};
            }

            data.acl.roleName = config.widgetParams.props.roleName;
            data.acl.roleCode = config.widgetParams.props.roleCode;
            data.acl.roleClientId = config.widgetParams.props.roleClientId;
            
        }

        data.dataflow = config.widgetParams.dataflow;

        $jQueryCromerrWidget.ajax({
            url: url,
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: "application/json",
            method: 'POST',
            type: 'POST',
            async: false,
            beforeSend: function (request) {
                //need to add header if we need to
                if (config.widgetParams.idToken) {
                    request.setRequestHeader("Authorization", "Bearer " + config.widgetParams.idToken);
                }
            },
            success: function (result) {
                activityIdCallback(result.activityId);
                if (bypassDisclaimer) {
                    $.unblockUI();
                }
            },
            error: function (jqXhr, textStatus, errorThrown) {
                modalClose();
                if (bypassDisclaimer) {
                    $.unblockUI();
                }
                config.error.call(this, errorThrown);
            }
        });
    }

    function isOIDCCapable(hasCromerrSession) {
        //if this has some value

        return config.idToken || hasCromerrSession;
    }
    //Load Required CSS and libraries
    loadCromerrResources();

    //Get config
    var data = {
        userRoleId: config.widgetParams.userRoleId
    }

    $jQueryCromerrWidget.ajax({
        url: baseUrl + '/CromerrScripts/GetConfig',
        data: data,
        dataType: 'json',
        method: 'POST',
        type: 'POST',
        success: function (result) {

            if (result.Status == "failure") {
                config.error.call(this, result.Message);
            }
            else {
                secondFactorConfig = result.Data.SecondFactorConfig;

                isOIDCMigratedUser = result.Data.IsOIDCMigrated;

                if (isOIDCMigratedUser) {
                    if (isOIDCCapable(result.Data.HasCromerrSession)) {
                        if (config.idToken) {
                            storeOIDCUser(config.widgetParams.FirstName, config.widgetParams.MiddleInitial, config.widgetParams.LastName, config.widgetParams.OrganizationName);
                        } else {
                            storeOIDCUser(result.Data.FirstName, result.Data.MiddleInitial, result.Data.LastName, result.Data.OrganizationName);
                        }
                    } else {
                        config.error.call(this, config.widgetParams.oidcSessionFailureMessage ? config.widgetParams.oidcSessionFailureMessage : "No Session exists for you to sign with, please hand-off from CDX again.");
                    }
                }

                //Build widget layout
                buildLayout();

                //Set up events
                initializeEvents();
                
                readyCallback();
            }
        },
        error: function (jqXhr, textStatus, errorThrown) {
            config.error.call(this, errorThrown);
        }
    });
};

$jQueryCromerrWidget.fn.preload = function () {
    this.each(function () {
        $jQueryCromerrWidget('<img/>')[0].src = this;
    });
}

// Expose functions so they can be called via $cromerrWidget.functionName on pages that include the built/final cromerrWidget.webpack.min.js
module.exports.initializeCromerrWidget = initializeCromerrWidget;